import React from 'react';
import RegisterPage from './RegisterPage/RegisterPage';

const Register = () => {
    return (
        <div>
            <RegisterPage />
        </div>
    );
};

export default Register;
